import React, { FormEvent } from 'react';
import { Button, DialogActions, DialogContent, DialogTitle, LinearProgress, Dialog, TextField, Typography } from '@mui/material';

export interface CreateFolderDialogProps {
    onSave: (folderName: string) => Promise<string[] | undefined>;
    onValidate?: (folderName: string) => string[];
    onCancel?: () => void;
    defaultText?: string;
    title?: string;
}

export function CreateFolderDialog(props: CreateFolderDialogProps) {
    const [folderName, setFolderName] = React.useState<string>(props.defaultText || '');
    const [errors, setErrors] = React.useState<string[]>([]);
    const [loading, setLoading] = React.useState<boolean>(false);

    function validate(): boolean {
        setErrors([]);

        if (!props.onValidate) {
            return true;
        }

        const validationErrors = props.onValidate(folderName);
        setErrors(validationErrors);

        if (validationErrors && validationErrors.length > 0) {
            return false;
        }

        return true;
    }

    async function handleCreate() {
        setLoading(true);
        if (validate()) {
            const saveErrors = await props.onSave(folderName);
            if (saveErrors) {
                setErrors(saveErrors);
            }
            setLoading(false);
        } else {
            setLoading(false);
        }
    }

    function handleCancel() {
        if (props.onCancel) {
            props.onCancel();
        }
    }

    function handleSubmit(event: FormEvent<HTMLFormElement>) {
        event.preventDefault();
        handleCreate();
    }

    return (
        <Dialog open={true} fullWidth>
            <DialogTitle>{props.title ? props.title : 'Create a folder'}</DialogTitle>
            <DialogContent>
                {errors && errors.map(error => (
                    <Typography key={error} variant="body1" color="error">
                        {error}
                    </Typography>
                ))}
                {errors && errors.length > 0 && <br />}
                {loading === true && <LinearProgress />}
                <form onSubmit={handleSubmit}>
                    <TextField
                        autoFocus
                        margin="dense"
                        id="folderName"
                        label="Folder name"
                        type="text"
                        fullWidth
                        variant="standard"
                        value={folderName}
                        onChange={e => setFolderName(e.target.value)}
                        disabled={loading}
                    />
                </form>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCreate} color="primary" disabled={loading}>
                    Save
                </Button>
                <Button onClick={handleCancel} color="primary" disabled={loading}>
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>)
}